import LimitUsageViewer from "../LimitUsageViewer";
import "./GeoLimitViewer.css";
import { jsx as _jsx } from "react/jsx-runtime";
const GeoLimitViewer = _ref => {
  let {
    label,
    limit
  } = _ref;
  return /*#__PURE__*/_jsx(LimitUsageViewer, {
    label: label,
    limit: `${limit.features.length} selected`,
    usage: limit && limit.features.length ? /*#__PURE__*/_jsx("ul", {
      className: "GeoLimitViewer__region-list",
      children: limit.features.map(feature => /*#__PURE__*/_jsx("li", {
        className: "GeoLimitViewer__region",
        children: feature.properties.featureName
      }, feature.id))
    }) : null,
    "data-sentry-element": "LimitUsageViewer",
    "data-sentry-component": "GeoLimitViewer",
    "data-sentry-source-file": "GeoLimitViewer.tsx"
  });
};
export default GeoLimitViewer;